module.exports = __webpack_public_path__ + "static/media/AIRLINE TONEARM.88a282dd.png";